export const profileWhatsAppAccountCreateStyles = {
  page: {
    paddingTop: 18,
  } as const,
  card: {
    borderRadius: 28,
    padding: '22px 18px 18px',
    background: '#f7f8ff',
    border: '1px solid rgba(193, 203, 255, 0.56)',
    boxShadow: '0 14px 32px rgba(31, 35, 41, 0.08)',
  } as const,
  title: {
    fontSize: 20,
    lineHeight: 1.25,
    fontWeight: 800,
    color: '#1f2430',
  } as const,
  subtitle: {
    marginTop: 10,
    fontSize: 13,
    lineHeight: 1.6,
    color: '#8f98ad',
    fontWeight: 600,
  } as const,
  fieldGroup: {
    marginTop: 16,
    paddingTop: 2,
    borderTop: '1px solid rgba(191, 205, 255, 0.8)',
  } as const,
  fieldLabel: {
    display: 'block',
    marginTop: 10,
    marginBottom: 10,
    fontSize: 15,
    lineHeight: 1.35,
    fontWeight: 800,
    color: '#1f2430',
  } as const,
  requiredMark: {
    marginRight: 4,
    color: '#ff6b6b',
  } as const,
  inputShell: {
    minHeight: 60,
    borderRadius: 22,
    background: '#ffffff',
    border: '1px solid rgba(31, 35, 41, 0.08)',
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    padding: '0 16px',
    boxShadow: '0 4px 14px rgba(31, 35, 41, 0.04)',
  } as const,
  inputIcon: {
    color: '#9aa3b8',
    flexShrink: 0,
  } as const,
  input: {
    '--font-size': '16px',
    '--placeholder-color': '#adb4c5',
    flex: 1,
    minWidth: 0,
  } as const,
  switchCard: {
    marginTop: 20,
    borderTop: '1px solid rgba(191, 205, 255, 0.8)',
    borderBottom: '1px solid rgba(191, 205, 255, 0.8)',
    padding: '18px 6px 18px 0',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 16,
  } as const,
  switchTitle: {
    fontSize: 15,
    lineHeight: 1.35,
    fontWeight: 800,
    color: '#1f2430',
  } as const,
  switchHint: {
    marginTop: 6,
    fontSize: 13,
    lineHeight: 1.55,
    color: '#98a0b1',
    fontWeight: 600,
  } as const,
  submitButton: {
    marginTop: 18,
    height: 52,
    borderRadius: 999,
    border: 'none',
    background: 'linear-gradient(90deg, #7d7af8 0%, #5f66f6 100%)',
    boxShadow: '0 16px 28px rgba(95, 102, 246, 0.24)',
    color: '#ffffff',
    fontWeight: 800,
    fontSize: 16,
  } as const,
  connectionCard: {
    marginTop: 18,
    padding: 16,
    borderRadius: 20,
    background: '#ffffff',
    border: '1px solid rgba(191, 205, 255, 0.8)',
  } as const,
  connectionHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
    marginBottom: 16,
  } as const,
  connectionTitle: {
    fontSize: 15,
    fontWeight: 800,
    color: '#1f2430',
  } as const,
  phoneGuardBox: {
    borderRadius: 16,
    padding: '12px 14px',
    marginBottom: 16,
    background: '#fff8e8',
    border: '1px solid rgba(255, 188, 86, 0.42)',
  } as const,
  phoneGuardLabel: {
    fontSize: 12,
    lineHeight: 1.4,
    fontWeight: 700,
    color: '#9a6a12',
  } as const,
  phoneGuardPhone: {
    marginTop: 4,
    fontSize: 18,
    lineHeight: 1.35,
    fontWeight: 900,
    color: '#1f2430',
    letterSpacing: 0.3,
  } as const,
  phoneGuardHint: {
    marginTop: 6,
    fontSize: 12,
    lineHeight: 1.55,
    color: '#9a6a12',
    fontWeight: 600,
  } as const,
  connectionLoading: {
    minHeight: 180,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 12,
    fontSize: 13,
    color: '#7f879b',
  } as const,
  codeText: {
    margin: '32px auto 18px',
    textAlign: 'center',
    fontSize: 28,
    letterSpacing: 5,
    fontWeight: 800,
    color: '#1f2430',
  } as const,
  qrImage: {
    width: 240,
    height: 240,
    display: 'block',
    margin: '0 auto 12px',
  } as const,
  connectionHint: {
    fontSize: 12,
    lineHeight: 1.6,
    color: '#7f879b',
    textAlign: 'center',
  } as const,
  connectionError: {
    borderRadius: 12,
    padding: 12,
    background: '#fff2f2',
    fontSize: 13,
    lineHeight: 1.5,
    color: '#d64c4c',
  } as const,
  resetButton: {
    marginTop: 14,
    color: '#6a6ff5',
    fontWeight: 800,
    fontSize: 13,
  } as const,
  // ========== Confirm phone modal styles (matches design mock) ==========
  modalMask: {
    position: 'fixed',
    inset: 0,
    background: 'rgba(20, 24, 38, 0.45)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0 24px',
    zIndex: 1200,
    backdropFilter: 'blur(2px)',
  } as const,
  modalCard: {
    width: '100%',
    maxWidth: 320,
    borderRadius: 24,
    padding: '28px 22px 22px',
    background: '#ffffff',
    boxShadow: '0 24px 48px rgba(31, 35, 41, 0.18)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
  } as const,
  modalIconBadge: {
    width: 56,
    height: 56,
    borderRadius: '50%',
    background: '#eef0ff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#6a6ff5',
  } as const,
  modalTitle: {
    marginTop: 16,
    fontSize: 18,
    lineHeight: 1.4,
    fontWeight: 800,
    color: '#1f2430',
  } as const,
  modalPhone: {
    marginTop: 12,
    fontSize: 22,
    lineHeight: 1.3,
    fontWeight: 900,
    color: '#5f66f6',
    letterSpacing: 0.6,
    wordBreak: 'break-all' as const,
  } as const,
  modalDescription: {
    marginTop: 14,
    fontSize: 13,
    lineHeight: 1.6,
    color: '#7f879b',
    fontWeight: 600,
  } as const,
  modalAlert: {
    marginTop: 16,
    width: '100%',
    borderRadius: 14,
    padding: '12px 14px',
    background: '#fff2f2',
    border: '1px solid rgba(214, 76, 76, 0.18)',
    display: 'flex',
    alignItems: 'flex-start',
    gap: 8,
    textAlign: 'left' as const,
  } as const,
  modalAlertIcon: {
    flexShrink: 0,
    color: '#d64c4c',
    marginTop: 1,
  } as const,
  modalAlertText: {
    fontSize: 12,
    lineHeight: 1.6,
    color: '#d64c4c',
    fontWeight: 700,
  } as const,
  modalActions: {
    marginTop: 20,
    width: '100%',
    display: 'flex',
    gap: 12,
  } as const,
  modalCancelButton: {
    flex: 1,
    height: 44,
    borderRadius: 14,
    border: 'none',
    background: '#f1f3f8',
    color: '#1f2430',
    fontWeight: 800,
    fontSize: 14,
  } as const,
  modalConfirmButton: {
    flex: 1,
    height: 44,
    borderRadius: 14,
    border: 'none',
    background: 'linear-gradient(90deg, #7d7af8 0%, #5f66f6 100%)',
    boxShadow: '0 12px 22px rgba(95, 102, 246, 0.26)',
    color: '#ffffff',
    fontWeight: 800,
    fontSize: 14,
  } as const,
} as const;
